'use client';

import Script from 'next/script';
import { GPT_SCRIPT_URL, SITE } from '@/app/constants';
import { useUserNexus } from '@/app/hooks';
import { initInterstitialSlot } from './utils/init-interstitial';

export const GPTScriptLoader = () => {
  const { isMissionWatchAdCredit } = useUserNexus();
  const isEligible = SITE === 'global' && isMissionWatchAdCredit;

  return (
    <>
      {isEligible && (
        <>
          <Script
            src={GPT_SCRIPT_URL}
            strategy="afterInteractive"
            onLoad={() => {
              initInterstitialSlot();
            }}
          />
          <Script id="gtm-script" strategy="lazyOnload">
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MBGHXM6W');`}
          </Script>
        </>
      )}
    </>
  );
};
